import React, { useState } from 'react';
import { Grid, Modal, Tooltip, Typography } from '@mui/material';
import { LineType } from './LineRegionChart';

type Props = {
    icon: string;
    graphType: LineType;
    content: string;
}

const ModalImage = ({ icon, graphType, content }: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        <>
            <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ color: '#161728', fontWeight: '700', marginBottom: 1 }}>
                    {LineType[graphType]}
                </Typography>
                <Tooltip title={content} arrow placement="top"
                    componentsProps={{
                        tooltip: {
                            sx: {
                                bgcolor: 'white',
                                color: '#5C5D68',
                                boxShadow: '0px 12px 24px rgba(22, 23, 40, 0.25)',
                                '& .MuiTooltip-arrow': {
                                  color: 'white',
                                },
                                fontSize: '12px'
                            },
                        },
                    }}>
                    <img
                        src={icon}
                        alt="filterTable"
                        className={`ml-2 mt-1 w-[15px] h-[15px] object-fill fill-black`}
                    />
                </Tooltip>
            </Grid>
        </>
    );
};

export default ModalImage;
